import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import MultiStepFormContext from "~/contexts/MultiSelectForm/MultiSelectFormContext";
import Button from "~/shared/Btn";
import TextareaInput from "~/shared/TextareaInput";
import TextInput from "~/shared/TextInput";
import NumberInput from "~/shared/NumberInput";
import { Content, Header, Footer } from "../styles";
import { Row, Col } from "react-bootstrap";

type PartyProps = {
    prevStep?: () => void;
    nextStep?: () => void;
    goToStep?: (step: number) => void;
    currentStep: number;
};

const extraFields = {
    party_type: {
        name: "Tipo de Festa",
        value: "",
        type: "texto",
    },
    number_guests: {
        name: "Numero de convidados",
        value: "",
        type: "numero",
    },
    adicional_info: {
        name: "Informações adicionais",
        value: "",
        type: "texto",
    },
};

const Party = ({ nextStep, goToStep }: PartyProps) => {
    const { values, confirmationStep, handleChange, updateValuesInLocalStorage, setValues } =
        useContext(MultiStepFormContext);

    const [addicionalInfo, setAddicionalInfo] = useState<string>(values?.extra?.adicional_info?.value || "");
    const [partyType, setPartyType] = useState<string>(values?.extra?.party_type?.value || "");
    const [numberGuests, setNumberGuests] = useState<string>(values?.extra?.number_guests?.value || "");

    const briefing = `Informações\nTipo de festa: ${
        values?.extra?.party_type?.value || partyType
    }\nNúmero de convidados: ${values?.extra?.number_guests?.value || numberGuests}`;

    const handleExtraFieldChange = async (name: string, value: any) => {
        if (Object.keys(extraFields).includes(name)) {
            handleChange(name, { ...extraFields[name], value, type: extraFields[name].type }, { extra: true });
        }
    };

    const validateAndNextStep = () => {
        if (!partyType.length || !numberGuests.length) {
            return toast.error("Tipo de festa e quantidade de convidados são obrigatórios!");
        }

        if (confirmationStep) {
            updateValuesInLocalStorage();
            return goToStep(confirmationStep);
        }

        return nextStep();
    };

    useEffect(() => {
        const localValues = JSON.parse(localStorage.getItem("values"));
        if (confirmationStep) {
            setValues(localValues);
        }
    }, []);

    useEffect(() => {
        handleChange("briefing", briefing);
    }, [briefing]);

    return (
        <>
            <Header>
                <h1>Defina o briefing do seu job</h1>
                <p>Precisamos de algumas informações para realizar o seu job!</p>
            </Header>

            <Content>
                <div className="title">
                    <p>Informações</p>
                    <div className="bar" />
                    <Row className="input-content">
                        <Col lg={6}>
                            <TextInput
                                name="party_type"
                                label="Tipo de festa"
                                value={partyType}
                                onChange={(name: string, value: string) => {
                                    handleExtraFieldChange(name, value);
                                    setPartyType(value);
                                }}
                            />
                        </Col>

                        <Col lg={6}>
                            <NumberInput
                                name="number_guests"
                                label="Número de convidados"
                                value={numberGuests}
                                onChange={(name: string, value: string) => {
                                    handleExtraFieldChange(name, value);
                                    setNumberGuests(value);
                                }}
                            />
                        </Col>
                    </Row>
                </div>
            </Content>
            <Content>
                <div className="title">
                    <p>Informações adicionais</p>
                    <div className="bar" />
                    <TextareaInput
                        name="adicional_info"
                        value={addicionalInfo}
                        placeholder="Descreva aqui qualquer informação adicional..."
                        rows={3}
                        onChange={(name: string, value: string) => {
                            handleExtraFieldChange(name, value);
                            setAddicionalInfo(value);
                        }}
                    />
                </div>
            </Content>

            <Footer>
                {confirmationStep ? (
                    <Button block onClick={validateAndNextStep}>
                        Salvar
                    </Button>
                ) : (
                    <>
                        <Button id="clickSegmentNext" block onClick={() => handleChange("category", 0)}>
                            Voltar
                        </Button>
                        <Button id="clickSegmentNext" block onClick={validateAndNextStep}>
                            Continuar
                        </Button>
                    </>
                )}
            </Footer>
        </>
    );
};

export default Party;
